export default "__VITE_ASSET__DjL$Tq5W__"